<!-- 广告管理 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="位置：">
        <el-select v-model="params.advPosition">
          <el-option value="0" label="全部"></el-option>
          <el-option value="1" label="游戏任务"></el-option>
          <el-option value="2" label="个人中心"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="params.status">
          <el-option value="0" label="全部"></el-option>
          <el-option value="1" label="待开始"></el-option>
          <el-option value="2" label="进行中"></el-option>
          <el-option value="3" label="已结束"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
        <el-button size="small" type="primary" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <el-table-column label="序号" prop="advId"></el-table-column>
      <el-table-column label="广告名称" prop="advName"></el-table-column>
      <el-table-column label="位置" prop="advPosition">
        <template slot-scope="scope">
          <span v-if="scope.row.advPosition ===1">游戏任务</span>
          <span v-if="scope.row.advPosition ===2">个人中心</span>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="advOrder"></el-table-column>
      <el-table-column label="跳转链接" prop="advUrl"></el-table-column>
      <el-table-column label="开始时间" prop="startTime"></el-table-column>
      <el-table-column label="结束时间" prop="endTime"></el-table-column>
      <el-table-column label="状态" prop="status"></el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="editAdv(scope.row)">编辑</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="detele(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small layout="total,prev,pager, next,sizes,jumper" 
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        :page-sizes="[10 ,20 , 30, 40, 50]"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 新增/编辑游戏 -->
    <el-dialog :title="title" top="20px" :visible.sync="dialogVisible"> 
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item label="广告名称：" prop="advName">
          <el-input type="text" v-model="form.advName" placeholder="请输入广告名称"></el-input>
        </el-form-item>
        <el-form-item label="位置：" prop="advPosition">
          <el-select v-model="form.advPosition">
            <el-option :value="1" label="游戏任务"></el-option>
            <el-option :value="2" label="个人中心"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序：" prop="advOrder">
          <el-input type="text" v-model="form.advOrder" placeholder="请输入排序，序号大的在前"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接：" required>
          <el-input type="text" v-model="form.advUrl" placeholder="请输入跳转链接"></el-input>
        </el-form-item>
        <el-form-item  prop="advPic">
          <template #label>
            <span class="label-with-break">
              广告图片：<br>
              (1200*190px)
            </span>
          </template>
          <ImageUpload :url="form.advPic" @image-uploaded="form.advPic = $event" />
        </el-form-item>
        <el-form-item label="日期：" required>
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();title='';dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
 
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    //ComponentName和文件名保持一致
    name:'advertisingManage',
    data() {
      //这里存放数据
      return {
        params:{
          advPosition: '0',//广告位置 0-全部 1-游戏任务 2-个人中心
          status: '0',//状态 0-全部 1-待开始 2-已发布 3-已结束
          pageNum:1,
          pageSize:10,
        },
        tableData: [],
        total: 0,
        dialogVisible: false, // 控制对话框的显示与隐藏
        title:'',//对话框标题
        buttonLoading: false,//按钮加载状态
        time:'',
        form:{
          advId:null,
          advName:'',
          advPosition:'',
          advOrder: '',
          advUrl: '',
          advPic: '',
          startTime:'',
          endTime:'',
          isDelete: ''
        },
        rules:{
          advName: [{ required: true, message: "请输入广告名称", trigger: "blur" }],
          advPosition: [{ required: true, message: "请选择位置", trigger: "blur" }],
          advOrder: [{ required: true, message: "请输入排序", trigger: "blur" }],
          advUrl: [{ required: true, message: "请输入跳转链接", trigger: "blur" }],
          advPic: [{ required: true, message: "请上传图片", trigger: "blur" }]
        }
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      handleAdd(){
        this.title = '新增广告';
        this.resetForm(); // 先重置表单
        
        // 关键：等待数据更新后再显示弹窗
        this.$nextTick(() => {
          this.dialogVisible = true;
        });
      },
      /**获取列表数据 */
      getTableList(){
        this.ajax.fetch({
          url: this.apis.advertisingManage.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      detele(row){
        this.resetForm();
        this.form.advId = row.advId;
        this.form.advName = row.advName;
        this.form.advPosition = row.advPosition;
        this.form.advOrder = row.advOrder;
        this.form.advUrl = row.advUrl;
        this.form.advPic = row.advPic;
        this.form.startTime = row.startTime;
        this.form.endTime = row.endTime;
        this.form.isDelete = '1';
        this.$confirm(`确定删除该项?`, `确认删除`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.ajax.fetch({
            url: this.apis.advertisingManage.update,
            disableLoading: true,
            method: 'post',
            param: this.form,
            successFunc: res=>{
              this.$message({
                type: 'success',
                message: `删除成功!`
              });
              this.resetForm();
              this.getTableList();
            },
            errorFunc: err=>{
              console.log(err);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: `已取消删除`
          });    
          this.resetForm();      
        });
      },
      editAdv(row){
        this.resetForm();
        this.title = '编辑广告';
        this.form.advId = row.advId;
        this.form.advName = row.advName;
        this.form.advPosition = row.advPosition;
        this.form.advOrder = row.advOrder;
        this.form.advUrl = row.advUrl;
        this.form.advPic = row.advPic;
        this.form.startTime = row.startTime;
        this.form.endTime = row.endTime;
        this.time = [row.startTime, row.endTime];
        this.dialogVisible = true;
      },
      /**确定 */
      confirm(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (!this.form.startTime) return this.$message.error('请选择时间段');
            if (!this.form.endTime) return this.$message.error('请选择时间段');
            if (this.form.advId == null) {
              this.ajax.fetch({
                url: this.apis.advertisingManage.add,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('新增成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }else{
              this.ajax.fetch({
                url: this.apis.advertisingManage.update,
                disableLoading: true,
                method: 'post',
                param: this.form,
                successFunc: res=>{
                  this.$message.success('编辑成功!');
                  this.dialogVisible = false;
                  this.resetForm();
                  this.getTableList();
                },
                errorFunc: err=>{
                  this.$message.error(err.info);
                }
              });
            }
          }
        });
      },
      dateChange(value) {
        this.form.startTime = value[0];
        this.form.endTime = value[1];
      },
      resetForm(){
        this.form = {
          advId:null,
          advName:'',
          advPosition:'',
          advOrder: '',
          advUrl: '',
          advPic: '',
          startTime:'',
          endTime:'',
          isDelete: ''
        }
      },
      resetParams(){
        this.params = {
          advPosition: '0',
          status: '0',
          pageNum:1,
          pageSize:10,
        }
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
    },
    beforeCreate() {}, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    beforeMount() {}, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
    },
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/advertisingManage/index.vue